import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';

@Component({
  selector: 'app-pill',
  imports: [DesyAngularModule, CommonModule],
  templateUrl: './pill.component.html',
  styleUrl: './pill.component.scss',
})
export class PillComponent {
  @Input() value: string = '';
  @Input() classe: string = '';
  @Input() isDeletable: boolean = false;
  @Output() accions = new EventEmitter<string>();

  onRemove(event: Event) {
    event.stopPropagation();
    this.accions.emit(this.value);
  }
}
